import { logClientError } from "@repo/next-utils/newrelic-client-utils";
import { useAuth } from "@repo/ui/auth";

type OnSecretExpiryParams = {
  auth: ReturnType<typeof useAuth>;
  secretName: string;
};

export const onSecretExpiry = async ({
  auth,
  secretName,
}: OnSecretExpiryParams): Promise<string | null> => {
  if (!auth.authClient) {
    const authError = new Error("Auth client is not available.");

    logClientError({ error: authError });

    throw new Error(authError.message);
  }

  if (secretName === "accessToken") {
    if (auth.status === "authenticated") {
      await auth.authClient?.silentTokenRefresh();
      return (await auth.authClient?.getAccessToken()) ?? null;
    }

    auth.authClient.redirectToLogin();
  }

  return null;
};
